// extracted by mini-css-extract-plugin
export default {"FooterContainer":"FooterWithCopyright_FooterContainer__1eC0Y"};